module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-42.075e84b0.png";